module.exports = __webpack_public_path__ + "img/Icon-Podium-Arrow.e4722f89.svg";